import RequireAdmin from './RequireAdmin';

export default RequireAdmin;
